import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import _chunk from 'lodash/chunk';
import _map from 'lodash/map';
import FormikSelectAllCheckbox from '@minecraft.formik-select-all-checkbox';
import FormikCheckbox from '@minecraft.formik-checkbox';
import { useTranslation } from '@blocs.i18n';
import { SelectOption } from '../../types';
import { Row, Column, Label } from '../../styles';

const StyledFormikSelectAllCheckbox = styled(FormikSelectAllCheckbox)<{ $withSelectAllBorder: boolean }>`
  ${(props) =>
    !props.$withSelectAllBorder &&
    `
    border: 0;
    margin: 0;
  `}
`;

type Props = {
  withSelectAll?: boolean;
  withSelectAllBorder?: boolean;
  isSelectAllBold?: boolean;
  selectAllLabel?: string;
  saveAsOption?: boolean;
  label?: string;
  disabled?: boolean;
  columnsAmount?: number;
  groupName: string;
  options: SelectOption[];
  className?: string;
};

const CheckboxGroup: FC<Props> = ({
  withSelectAll = false,
  withSelectAllBorder = true,
  isSelectAllBold = false,
  selectAllLabel,
  saveAsOption = true,
  disabled = false,
  label,
  columnsAmount,
  groupName,
  options,
  className,
}) => {
  const { t } = useTranslation();

  const groupedOptionsByColumns = useMemo(
    () => (columnsAmount ? _chunk(options, Math.ceil(options.length / columnsAmount)) : [options]),
    [options]
  );

  return (
    <div className={className}>
      {withSelectAll && (
        <StyledFormikSelectAllCheckbox
          $withSelectAllBorder={withSelectAllBorder}
          saveAsOption={saveAsOption}
          isBold={isSelectAllBold}
          value={saveAsOption ? options : _map(options, (option) => option.value)}
          label={selectAllLabel || t('common:form.label.selectAll')}
          disabled={disabled}
          groupName={groupName}
        />
      )}
      {Boolean(label) && <Label>{label}</Label>}
      <Row>
        {_map(groupedOptionsByColumns, (columnOptions, index) => (
          <Column key={`col_${index}`} $columnsAmount={columnsAmount}>
            {_map(columnOptions, (option, optIndex) => (
              <FormikCheckbox
                key={`col_${index}-${optIndex}-${option.value}`}
                saveAsOption={saveAsOption}
                groupName={groupName}
                value={option.value}
                disabled={disabled}
                label={option.label}
                data-qa-id={option.value}
              />
            ))}
          </Column>
        ))}
      </Row>
    </div>
  );
};

export default CheckboxGroup;
